import React from 'react';
import { motion } from 'framer-motion';

const Stats = () => {
  const stats = [
    { label: "Projects Completed", value: "2500+", icon: "🏗️" },
    { label: "Happy Clients", value: "2000+", icon: "😊" },
    { label: "Team Members", value: "10+", icon: "👥" },
    { label: "Years Experience", value: "28+", icon: "⚡" }
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.2,
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6 }
    }
  };

  return (
    <section className="py-16 bg-gradient-to-r from-gray-800 to-gray-900 text-white">
      <div className="max-w-6xl mx-auto px-6">
        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          className="grid grid-cols-2 md:grid-cols-4 gap-8"
        >
          {stats.map((stat, index) => (
            <motion.div
              key={index}
              variants={itemVariants}
              className="bg-gray-700/50 backdrop-blur-md p-8 rounded-lg text-center hover:bg-yellow-400/10 transition-all duration-300 border border-gray-600"
            >
              <div className="text-5xl mb-4">{stat.icon}</div>
              <h3 className="text-4xl font-bold text-yellow-400 mb-2">{stat.value}</h3>
              <p className="text-gray-300 text-lg">{stat.label}</p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Stats;